import { render, staticRenderFns } from "./Iphone.vue?vue&type=template&id=125f3e1e&scoped=true&"
import script from "./Iphone.vue?vue&type=script&lang=js&"
export * from "./Iphone.vue?vue&type=script&lang=js&"
import style0 from "./Iphone.vue?vue&type=style&index=0&id=125f3e1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125f3e1e",
  null
  
)

export default component.exports